<template>
  <div>
    <title>单品库存</title>
    <section class="mainPart">
      <!--S 头部tab-->
      <header class="tabHeader">
        <p>
          <router-link v-if="userInfoMd.isopencardstock==1" :to="{name:'券卡库存'}">券卡库存</router-link>
          <a href="javascript:;" class="isActive">单品库存</a>
          <router-link v-if="userInfoMd.cantransferinv==1" :to="{name:'单品库存调拨记录',params:{singlecode:'0'}}">单品库存调拨记录</router-link><!--默认进来是所有的库存调拨记录-->
        </p>
      </header>
      <!--E 头部tab-->
      
      <!--S 检索-->      
      <el-form inline :model="formInline" class="searchForm">
        <el-form-item label="单品">
          <el-input placeholder="请输入单品名称" clearable v-model="formInline.keyword"></el-input>
        </el-form-item>
        <el-form-item label="上/下架">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option label="上架" value="1"></el-option>
            <el-option label="下架" value="0"></el-option>
          </el-select>
        </el-form-item>  
        <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->    
      <!--S 库存管理列表-->
      <el-table :data="singleGoodsInvData" v-loading="loading" ref="singleGoodsInv" class="orderTable comTable" border :maxHeight="tableHeight">         
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column label="单品" prop="singlename" sortable fixed min-width="250">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.singlename?scope.row.singlename:''">{{scope.row.singlename ||'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="剩余库存" prop="totalinv" sortable min-width="180">
          <template slot-scope="scope">
            <span class="priceFont">{{scope.row.totalinv ||'0'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="已消耗库存" prop="consumeinv" sortable min-width="180">
          <template slot-scope="scope">
            <span class="priceFont greyColor">{{scope.row.consumeinv ||'0'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="bsale" sortable min-width="180">
          <template slot-scope="scope">
            <el-switch :value="scope.row.bsale?true:false" disabled :width="55" class="isSwitch" :active-text="scope.row.bsale?'上架':'下架'"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100" v-if="userInfoMd.cantransferinv==1">
          <template slot-scope="scope">
            <p class="handle">
              <span title="详情" @click="viewDetail(scope.row.singlecode)"><i class="icondetails"></i></span>
              <span title="库存调拨" v-if="scope.row.totalinv" @click="getShowTransferDlog(scope.row)"><i class="icondb"></i></span>
            </p>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <!--E 库存管理列表-->
       <!-- S 分页 -->
        <Page :pageTotal="pagebBean.totalnum" :pagers="5" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
       <!-- E 分页 -->
    </section>
    <!-- S 库存调拨 -->
    <TransferStock v-if="transferDlog" :transferDlog="transferDlog" :singleInfo="singleInfo" :userInfo="userInfoMd" @closeCld="getCloseTransferDlog"></TransferStock>
    <!-- E 库存调拨 -->
  </div>
</template>
<script>
import Api from '@/apis/api';
export default {
  name: 'ShopInventoryManage',
  data () {
    return {
      userInfoMd:'',
      loading:false,
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
      formInline:{
        keyword:'',//单品编号
        status:'',//上下架
      },//检索表单
      singleGoodsInvData:[
      ],//单品库存数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      transferDlog:false,//库存调拨弹窗显隐
      singleInfo: '', // 操作的单品信息
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    TransferStock: resolve => require(["@/components/GoodsFolder/GoodsSingle/TransferStock.vue"], resolve), //库存调拨
  },
  watch: {

  },
  methods: {
    // 打开库存调拨弹窗
    getShowTransferDlog(row,type){
      this.singleInfo = row;
      this.transferDlog = true;
    },
    // 关闭库存调拨弹窗
    getCloseTransferDlog(){
      // 获取单品列表
      this.getSingleitemList1()
      this.transferDlog = false;
    },
    //查看详情
    viewDetail(singlecode){
      this.$router.push({
        name:'单品库存调拨记录',
        params:{
          singlecode:singlecode
        }
      })
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.singleGoodsInv.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },
    // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getSingleitemList1();
    },
    search(){
      this.currentPage =1;
      this.getSingleitemList1();
    },
    getSingleitemList1(){
      this.loading  =true;
      let param = {
           keyword:this.formInline.keyword, 
           bsale:this.formInline.status, 
           pageparam:{
                pagesize: this.pageSize, //每页条数
                currentpage: this.currentPage, //当前页数
                isnewcomp: 1 //是否需要重新统计页数
            }   
      }
       Api.GET_SINGLEITEMLIST1(param).then(res =>{
          if(res.data.status=="200"){
            this.loading  =false;
            this.singleGoodsInvData = res.data.data;
            this.pagebBean = res.data.pagebean;
            this.$refs.singleGoodsInv.bodyWrapper.scrollTop = 0;
          }else{
            this.loading  =false;
            this.pagebBean.totalnum =0;
            this.singleGoodsInvData =[];
          }
       })
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted (){
    if(localStorage.getItem('userInfoMd')){
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
      if(this.userInfoMd.objtype!=0) {
        Api.GET_FLOWDETAIL({flowcode: this.userInfoMd.pflowcode}).then(res => {
          if(res.data.status == "200") {
            this.userInfoMd.pflowname = res.data.data.flowname;
          }
        })
      }
    }
    this.getSingleitemList1();
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight();
    }, 200); 
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.searchForm {padding-top:64px;}
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pdr70 {padding-right:70px;width:auto;}
</style>



// WEBPACK FOOTER //
// src/views/InventoryMange/ShopInventoryManage.vue